// OPHORUS
// Tronque le contenu <span> d'un conteneur de badges (categories, interets)
// pour tenir sur une seule ligne, avec un badge "..." si tout ne rentre pas.
// Reutilise par pages/product.js (.__product_interests) et utils/categories.js
// (._categories, cartes produit).
//
// Le conteneur a une largeur fixe (impose par la grille/flex parent) : on ne
// peut donc pas se fier a son scrollWidth pour detecter le debordement (il
// vaut toujours au moins la largeur du conteneur, quel que soit le contenu).
// On mesure a la place la largeur reelle cumulee des badges au fur et a
// mesure qu'on les ajoute.
function outerWidth(el) {
	const style = getComputedStyle(el);
	return el.getBoundingClientRect().width
		+ parseFloat(style.marginLeft || 0)
		+ parseFloat(style.marginRight || 0);
}

export default function fitEllipsisLine(container) {
	if (!container) return;

	if (!container.dataset.fitLabels) {
		const labels = [...container.querySelectorAll("span")]
			.filter((span) => !span.classList.contains("_more"))
			.map((span) => span.textContent);
		container.dataset.fitLabels = JSON.stringify(labels);
	}

	const labels = JSON.parse(container.dataset.fitLabels);
	if (!labels.length) return;

	container.innerHTML = "";
	const maxWidth = container.clientWidth;

	const ellipsis = document.createElement("span");
	ellipsis.className = "_more";
	ellipsis.textContent = "...";
	container.appendChild(ellipsis);
	const ellipsisWidth = outerWidth(ellipsis);
	ellipsis.remove();

	let usedWidth = 0;
	let shown = 0;

	for (let i = 0; i < labels.length; i++) {
		const span = document.createElement("span");
		span.textContent = labels[i];
		container.appendChild(span);
		const spanWidth = outerWidth(span);

		const hasMore = i < labels.length - 1;
		const limit = maxWidth - (hasMore ? ellipsisWidth : 0);

		if (usedWidth + spanWidth > limit && shown > 0) {
			span.remove();
			break;
		}

		usedWidth += spanWidth;
		shown++;
	}

	if (shown < labels.length) {
		container.appendChild(ellipsis);
	}
}
